import { render, staticRenderFns } from "./CertificadosTodosFecha.vue?vue&type=template&id=45e4c478"
import script from "./CertificadosTodosFecha.vue?vue&type=script&lang=js"
export * from "./CertificadosTodosFecha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports